import CandidateAvatar from "@/assets/candidates/silvi_avatar.jpeg";

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User } from "lucide-react";

const CandidateInformationInfoCardContent = () => {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-6 items-center">
        <h1 className="w-full text-secondary-foreground text-3xl">
          Join an exclusive community of top executives
        </h1>
        <p className="w-full text-secondary-foreground text-lg">
          Get matched with projects and roles that align with your
          expertise—without endless applications.
        </p>
      </div>
      <div className="p-4 flex flex-col gap-8 self-stretch rounded-lg bg-[rgba(255,255,255,0.05)]">
        <p className="text-xl font-medium text-[rgba(255,255,255,0.9)]">
          “As a solopreneur, I’m usually on my own. Venturous made the entire
          process easy. It felt like having a friend who had my back.”
        </p>
        <div className="flex gap-4 self-center items-center">
          <Avatar className="size-16 min-w-16">
            <AvatarImage
              src={CandidateAvatar}
              className="object-cover object-center"
            />
            <AvatarFallback>
              <User className="size-16 text-accent-og-foreground" />
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col gap-1 items-start">
            <p className="text-lg font-bold text-white">Silvi Spector</p>
            <p className="text-base font-normal text-white/80">
              Venturous Member
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateInformationInfoCardContent;
